<template lang="pug">
  div
      modal-trocar-responsavel(
        v-if="showModalResponsavel",
        :processo="processoTrocado",
        @closeModal="FECHAR_MODAL_RESPONSAVEL",
        @refresh="refresh"
      )
      app-modal-visualizar-completo(
          v-if="showModalVisualizarProcesso && idProcesso !== null",
          @closeModal="showModalVisualizarProcesso = false",
          :idProcesso="idProcesso",
          :protocolo="protocolo",
          :numeroProcesso="numeroProcesso",
          :tipo="tipoProcesso"
      )
      app-modal-solicitar-retificacao(
        v-if="solicitarRetificacao",
        :idProcesso="idProcesso",
        :numeroProcesso="numeroProcesso",
        :setor="setorSelecionado",
        @closeModal="solicitarRetificacao = false"
      )
      el-card.card-container(shadow="hover")
          filtro(
              @pesquisar="pesquisar",
              @limpar="clear",
              :showOs="true",
              :showMunicipios="true",
              :configuracaoFiltro="configuracaoFiltro",
              :filtroRapido="filtroRapido"
              :showFiltroTipoMultiplo="showFiltroTipoMultiplo"
          )
      app-listagem(
        :has-refresh-button="true",
        :showButtonOrdemServico="false",
        :showButtonAssinatura="false",
        :has-expansivel="false",
        :json-headers="colunas",
        :json-data="items",
        :totalElements="totalElements",
        :pagina="filtro.pagina",
        :hasFiltroRapido="true",
        :filtro="filtro",
        caixa="CAIXA_AGUARDANDO_PLANTA_MEMORIAL"
        @atualizarFiltro="atualizarFiltro",
        @updateListagem="refresh",
        @changePage="changePage",
        @sort="sort",
        @executar="executar",
        @exportarCsvFiltroAnalise="exportarCsvFiltroAnalise"
        @regerar="REGERAR_PROCESSOS"
        @selectItem="SELECIONA_PROCESSO"
        :showButtonRegerar="true"
      )
  </template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppListagem from '@/components/AppListagem'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import ModalTrocarResponsavel from '@/screens/analise/components/ModalTrocarResponsavel'
import AppModalSolicitarRetificacao from '@/screens/analise/components/modal/AppModalSolicitarRetificacao'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
const { filtro, showFiltroTipoMultiplo } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto,
    ModalTrocarResponsavel,
    AppModalSolicitarRetificacao
  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('CAIXA_AGUARDANDO_PLANTA_MEMORIAL'),
      idProcesso: null,
      solicitarRetificacao: false,
      processo: {},
      showModalVisualizarProcesso: false,
      items: [],
      idsProcessos: [],
      protocolo: '',
      tipoProcesso: '',
      totalElements: 0,
      setorSelecionado: null,
      numeroProcesso: '',
      configuracaoFiltro: {
        filtroSituacao: filtro?.filtroSituacao?.CAIXA_EMISSAO_TITULO || [],
        filtroResponsavel: filtro?.filtroResponsavel?.CAIXA_EMISSAO_TITULO || [],
        filtroBairro: filtro?.filtroBairro?.CAIXA_EMISSAO_TITULO || []

      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', marcado: () => true, ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 4, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        { id: 5, titulo: 'Situação', propriedade: 'status', ordem: 6, acoes: [] },
        { id: 4, titulo: 'Município', propriedade: 'municipio', sortable: true, ordem: 3, acoes: [], exibir: () => true },
        {
              id: 6, titulo: 'Ações', propriedade: 'tipo', ordem: 7, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso },
            { id: 2, nome: 'Analisar manualmente', icone: 'fa-file-contract', codigo: 'TRAMITAR_MANUALMENTE', ordem: 2, show: () => true },
            { id: 3, nome: 'Solicitar Retificação', icone: 'fa-edit', codigo: 'SOLICITAR_RETIFICACAO', ordem: 3, show: () => true }
          ]
        }
      ],
      showFiltroTipoMultiplo,
      filtroRapido: null,
      processoTrocado: null,
      showModalResponsavel: false
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  async created () {
    this.usuario = await this.usuarioLogado
    this.idUsuario = this.usuario.id
    this.setorSelecionado = this.usuario.perfilSelecionado.setor.codigo
  },

  watch: {
    async '$route' (to, from) {
      this.init()
    }
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    })
  },

  methods: {
    ...mapActions({
      cancelarBoletoDesarquivamento: 'processo/cancelarBoletoDesarquivamento',
      exportarCsvAnalise: 'processo/exportarCsvAnalise',
      tramitarComAcao: 'processo/tramitarComAcao',
      regerar: 'filaPlantaMemorial/regerar'
    }),
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.setDadosProcesso(item)
      this.showModalVisualizarProcesso = true
    },
    async TRAMITAR_MANUALMENTE (_this, { item }) {
      this.confirmBox(this.$messages.CONFIRMAR_ANALISE_MANUAL_PLANTA_MEMORIAL, this.$messages.TITULO_WARNING, async () => {
        await this.tramitarComAcao({
          processoId: item.id,
          acao: 'AGUARDANDO_DISTRIBUICAO.SISTEMA.COMISSAO_ILHA.AUTOCOMPLETE'
        })
        this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Processo enviado para caixa de entrada')

        await this.refresh()
      })
    },
    FECHAR_MODAL_RESPONSAVEL () {
      this.showModalResponsavel = false
    },
    SOLICITAR_RETIFICACAO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.solicitarRetificacao = true
    },
    REGERAR_PROCESSOS () {
      if (this.idsProcessos.length > 0) {
        this.confirmBox(this.$messages.AVISO_REGERAR, this.$messages.TITULO_WARNING,
          async () => {
            await this.regerar(this.idsProcessos)
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Processo(s) enviados para a Fila')
            location.reload()
            await this.refresh()
          },
          () => { }
        )
      }
    },
    SELECIONA_PROCESSO (item) {
      item.selecionado = !item.selecionado
      if (item.selecionado) {
        this.idsProcessos.push(item.id)
      } else {
        this.idsProcessos.splice(this.idsProcessos.indexOf(item.id), 1)
      }
    },
    setDadosProcesso (item) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.processo = item
      this.protocolo = item.numeroProtocolo
      this.tipoProcesso = item.tipoCodigo
      this.processo = item
    },
    atualizarFiltro (novoFiltro) {
      this.filtroRapido = novoFiltro
    },
    isEstadoMA () {
      return process.env.ESTADO === 'ma'
    },
    exportarCsvFiltroAnalise () {
      this.exportarCsvAnalise(this.filtro)
    }
  }
}
</script>
<style lang="scss" scoped>
    .card-container {
      margin: 20px;
      border-radius: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaAguardandoPlantaMemorial.vue